import { paymentsClient } from "@/shared/rpc/clients";
import { bonusStore } from "@/shared/stores/BonusStore";
import { userStore } from "@/shared/stores/UserStore";
import { OrderStatus } from "@cronika/proto/common/billing_pb";
import { useEffect, useState } from "react";

export const useBonusBanner = () => {
  const [hasFirstDeposit, setHasFirstDeposit] = useState<boolean | null>(null);

  useEffect(() => {
    const check = async () => {
      try {
        const result = await paymentsClient.listDeposits({
          pagination: { page: 1, size: 1 },
          status: [OrderStatus.COMPLETED],
        });
        const total = result.pagination?.total ?? (result.data?.length ?? 0);
        setHasFirstDeposit(total > 0);
      } catch {
        setHasFirstDeposit(false);
      }
    };
    check();
  }, []);

  const hasRegistrationPromo = !!userStore.user?.promoCode;

  const hasActiveBonus = bonusStore.isActive;

  const showBanner = hasFirstDeposit !== null && !hasRegistrationPromo && !hasActiveBonus && !hasFirstDeposit;

  return { showBanner };
};
